import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext, useRef } from 'react';
import ReactDOM from 'react-dom';
import useOnScreen from 'pathfinder/modules/shared/useOnScreen';
import styles from './MobileStickyButton.module.scss';
import { Tooltip } from './Tooltip';
import { TooltipContext } from './Context';
import { HeartIcon } from './icons';
export const MobileStickyButton = ({ isAlreadyAdded, handleClick, root }) => {
    const buttonRef = useRef(null);
    const isOnScreen = useOnScreen(buttonRef);
    const { onFollow } = useContext(TooltipContext);
    const onClick = (e) => {
        e.preventDefault();
        buttonRef.current.blur();
        onFollow(handleClick());
    };
    const wrapper = (_jsxs(_Fragment, { children: [_jsx("button", Object.assign({ className: `wds-button wds-is-text mobile-global-navigation__button ${styles.button}`, onClick: onClick, ref: buttonRef }, { children: _jsx(HeartIcon, { isFilled: isAlreadyAdded }, void 0) }), void 0), _jsx(Tooltip, { variant: "mobile-sticky", isOnScreen: isOnScreen }, void 0)] }, void 0));
    return ReactDOM.createPortal(wrapper, root);
};
